<template>
    <div>
        <div v-if="! onlineStatus.web && ! onlineStatus.api" class="connection-notice no-web-connection">
            No internet connection detected.
        </div>

        <div v-else-if="onlineStatus.web && ! onlineStatus.api" class="connection-notice no-api-connection">
            Could not connect to API
        </div>
    </div>
</template>

<script>
    import Ping from 'ping.js'
    import { mapMutations, mapState } from 'vuex'
    import GeoLocation from '../../support/GeoLocation'

    const pinger = new Ping({
        // Set a 10 second timeout
        timeout: 10000
    });
    // The time in ms between pings
    const retryTime = 10000;

    export default {
        computed: {
            ...mapState(['onlineStatus']),
        },

        methods: {
            ...mapMutations(['setApiStatus', 'setWebStatus']),

            triggerCheck() {
                this.checkApi()
                    .then(response => {
                        this.setApiStatus(true);
                        this.setWebStatus(true);
                        setTimeout(this.triggerCheck, retryTime);
                    })
                    .catch(error => {
                        this.setApiStatus(false);

                        this.checkInternet()
                            .then(() => {
                                this.setWebStatus(true);
                                setTimeout(this.triggerCheck, retryTime);
                            })
                            .catch(() => {
                                this.setWebStatus(false);
                                setTimeout(this.triggerCheck, retryTime);
                            });
                    })
            },

            checkApi() {
                // GeoLocation.getLocation()
                //     .then(location => console.log(location));

                return axios.head('/online')
            },

            checkInternet() {
                return new Promise((resolve, reject) => {
                    pinger.ping("https://google.com", function (error, data) {
                        error ? reject() : resolve();
                    });
                });
            }
        },

        mounted() {
            this.triggerCheck();
        }
    }
</script>

<style scoped>
    .connection-notice {
        position: fixed;
        color: white;
        top: 0;
        left: 0;
        width: 100%;
        z-index: 1000;
        text-align: center;
    }

    .no-web-connection {
        background-color: red;
    }

    .no-api-connection {
        background-color: orange;
    }
</style>
